export const workspaceBaseApi = '/workspaces/{workspaceId}';

export interface MockServiceApiParams {
  limit?: number;
  skip?: number;
  serviceId?: number;
  sort?: string;
  dataType?: string;
}
